import './App.css';
import './index.css';
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";

import Dashboard from './components/pages/sidebar/sidebarMenu';
import SignInPage from './components/pages/signin/signin';
import { RouterProvider, createBrowserRouter, useNavigate } from 'react-router-dom';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { createTheme } from '@mui/material/styles'; 
import RouteProtection from './components/RouteProtection/RouteProtection';
import AdminRouteProtection from './components/RouteProtection/AdminRouteProtection';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { clarity } from 'react-microsoft-clarity';
import mixpanel from "mixpanel-browser";

import ProtectPlanRoutes from './components/RouteProtection/PlanProtectRoute';
import { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import LoadingComponent from './components/GlobalComponents/GlobalLoading';
import EditQuestionListSkeleton from './components/pages/sidebar/sidbarOptionsContent/QuestionList/components/EditQuestionListSkeleton';
import CoursesSkeleton from './components/pages/sidebar/sidbarOptionsContent/Gamizign/Components/CoursesSkeleton';
import PaymentRouteProtection from './components/RouteProtection/PaymentRouteProtection';
import BrowserUpdate from './browserUpdate';
import { initGA } from "./analytics"
import NetworkStatus from './components/GlobalComponents/networkStatus/networkStatus';
import OfflineUI from './components/GlobalComponents/networkStatus/statusUi';
import sadDog from './assets/icons/ActivityContentIcons/Gamizign_Courses/Course/AnalyticsCourse/sadDog.png';
import SignupProtection from './components/RouteProtection/SignupProtection';


// 
const NewCourse = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/newCourse'));
const NewAiCourse = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/newAiCourse'));
const CustomizeAiCourse = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/customizAiCourse'));
const Activity = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/activity'));
const Adding = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/adding'));
const QuestionList = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/QuestionList/questionList'));
const Gamizign = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Gamizign/gamizign'));
const Insights = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Insights/insights'));
const LearnerList = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/LearnerList/learnerList'));
const Settings = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Settings/settings'));
const CreatingPptx = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/CreatingPptx'));
const CreatingPdf = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/CreatingPdf'));
const Customizing = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/customizing'));
const SavingQuestions = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/Saving/savingQuestion'));
const ChooseGame = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/Saving/chooseGame'));
const GameDone = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/Saving/gameDone'));
const PlayGame = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/Saving/WebGl'));
// Patch 3
const AddingActivityType = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/JourneyActivity/activityType'));
const MultiActivy = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Activity/JourneyActivity/MultiActivity/mutiActivity'));
const QuestionListEdit = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/QuestionList/components/EditQuestionList'));
const EditReferencedQList = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/QuestionList/editReferencedQList'));
const PdfDownloadQuestionList = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/QuestionList/components/PdfDownloadQuestionList'));
const CourseBar = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Gamizign/Components/CourseBar'));
const CourseAnalytics = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Gamizign/Components/Analytics'));
const HomeWork = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Gamizign/Components/HomeWork/HomeWork'));
const ViewCourse = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Gamizign/Components/ViewCourse'));
const GamizignWorld = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/The Gamizign World/gamizignWorld'));
const ActivityEvaluation = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Gamizign/Components/HomeWork/ActivityEva'));
const LearnerEva = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Gamizign/Components/HomeWork/LearnerEva'));
const Admin = lazy(()=>import('./components/Admin/Admin'));
const AllStudentsPerformance = lazy(()=>import('./components/Admin/AllStudents'));
const AllInstructorsPerformance = lazy(()=>import('./components/Admin/AllInstructors'));
const ViewQuestionsList = lazy(()=>import('./components/Admin/Questionlist/ViewQlist'));
//
const SignUp = lazy(()=>import('./components/pages/SignUp/Signup')); 
const SignUpAccount = lazy(()=>import('./components/pages/SignUp/SignUpAccount'));
const ForgotPassword = lazy(()=>import('./components/pages/signin/ForgotPassword')); 
const PaymentForm = lazy(()=>import('./components/payment')); 
const UpgradePlan = lazy(()=>import('./components/RepayUpgrade/upgardePlan')); 
const CancelSubscription = lazy(()=>import('./components/pages/sidebar/sidbarOptionsContent/Settings/components/CancelSubscription')); 
const Players = lazy(()=>import('./components/players')); 
const SuperAdmin = lazy(()=>import('./components/SuperAdmin/SuperAdmin')); 
const Chat = lazy(()=> import ('./components/Chat/ChatCustomComponent'));
const newAiCourse = lazy(() => import ('./components/pages/sidebar/sidbarOptionsContent/Activity/Newcourse/newAiCourse'));
const GoldCourse = lazy(()=> import ('./components/GlobalComponents/AiCourse/GoldCourse'));
function App(language) {
  const {t, i18n} = useTranslation();
  document.body.setAttribute('data-lang', i18n.language);
  const LicenceType = parseInt(Cookies.get("plan"));
  const LearnersList = localStorage.getItem("LearnersList");
  const Onboarding = parseInt(localStorage.getItem("accountActive"));
  const currentPage = window.location.pathname;  
  const user_type = localStorage.getItem("user_type");
  const id = Cookies.get("instructor_id");
  const admin_id = Cookies.get("admin_id");
  const token = Cookies.get('token');
  const getInitialElement = () => {
    // Route to create course when courses are 0
    if (Onboarding === 0 && token && id && user_type === 'Instructor' && LearnersList === 'show' && currentPage !== '/Dashboard/CreateCourse') {
      window.location.href = '/Dashboard/CreateCourse';
      sessionStorage.setItem("tab", 1);
      return;
    };
    return (token && id && user_type === 'Instructor' ? <div className='flex'><Dashboard drawerWidth={drawerWidth} setDrawerWidth={setDrawerWidth} setMode={setMode} mode={mode} />{(LicenceType === 3 || LicenceType === 5) ? <GamizignWorld setMode={setMode} mode={mode} /> : <Insights setMode={setMode} mode={mode} />}</div>
      : token && admin_id && user_type === 'Admin' ? <Admin drawerWidth={drawerWidth} setDrawerWidth={setDrawerWidth} setMode={setMode} mode={mode} /> : <SignInPage setMode={setMode} mode={mode} />);
    // return id === null ? <SignInPage /> : <Dashboard />;
  };
  const ErrorCard = () => {
    const handleRefresh = () => {
      // window.location.href ='/';
      window.location.reload();
    }
    return (
      <div className='flex justify-center'>
        <div> <p className="text-xl font-bold flex justify-center">{t('Gamizign.SomethingWentWrong')}</p>
        <p className='flex justify-center'><button onClick={handleRefresh}>{t('NetworkStatus.Reload')}</button></p>
          <p className='flex justify-center'><img src={sadDog} alt="" /></p>
        </div>
      </div>
    )
  }
  // For Sidebar scren adjustment
  const [drawerWidth, setDrawerWidth] = useState(window.innerWidth > 1024 ? 240 : 60);
  const [NetworkStatusVar, setNetworkStatusVar] = useState('online');
  useEffect(() => {
    const handleResize = () => {
      setDrawerWidth(window.innerWidth > 1024 ? 240 : 60);
    }; 
    //i18n.changeLanguage(navigator.language);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
    // Init Google analytics
    useEffect(() => {
      initGA();
    }, []);
    const cacheRtl = createCache({
      key: language === "ar" ? 'muirtl' : 'mui',
      stylisPlugins: language === "ar" ? [prefixer, rtlPlugin] : [],
    });
  const font = i18n.language === 'ar' ? 'Noto Sans Arabic, sans-serif' : 'Calibri, sans-serif';

  const [mode, setModeState] = useState(() => {
    const saved = localStorage.getItem('theme-mode');
    return saved === 'dark' || saved === 'light' ? saved : 'light';
  });

  const setMode = (newMode) => {
    setModeState((prev) => {
      const next = typeof newMode === 'function' ? newMode(prev) : newMode;
      localStorage.setItem('theme-mode', next);
      return next;
    });
  };
  const theme = createTheme({
    typography: {
      allVariants: {
        fontFamily: language === "ar" ? "'Noto Sans Arabic', sans-serif" : "'Calibri', sans-serif",
        textTransform: "none",
        fontSize: 16,
      },
    },
    direction: language === "ar" ? "rtl" : "ltr", // This sets the layout direction
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            textAlign: language === "ar" ? "right" : "left",
            fontFamily: font,
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            "&::before": {
              display: "none",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '& input::placeholder': {
              fontFamily: font,
            },
          },  
          input: {
            textAlign: language === "ar" ? "right" : "left",
            fontFamily: font,
          },
          notchedOutline: {
            '& legend': {
              textAlign: i18n.language === 'ar' ? 'right' : 'left',
              fontFamily: font,
            },
          },  
        },
      },
      MuiSlider: {
        styleOverrides: {
          root:{
            direction: language === "ar" ? "rtl" : "ltr",
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            textAlign: i18n.language === 'ar' ? 'right' : 'left',
            fontFamily: font,
            direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
          },
          icon: {
            right: language === "ar" ? 'unset' : 10,
            left: language === "ar" ? 10 : 'unset',
          },
        },
      },
      DatePicker: {
        styleOverrides: {
          root: {
            direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
            fontFamily: font,
          },
          input: {
            textAlign: i18n.language === 'ar' ? 'right' : 'left',
          },
        },
      },
      
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontFamily: font,
            textAlign: i18n.language === 'ar' ? 'right' : 'left',
            direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
          },
        },
      },  
      MuiInputLabel: {
        styleOverrides: {
          root: {
            right: i18n.language === 'ar' ? '0.9rem !important' : '',
            left: i18n.language === 'ar' ? 'inherit !important' : '',  
            textAlign: language === "ar" ? "right" : "left",
            fontFamily: font,
          },
        },
      },
      MuiFormLabel:{
        styleOverrides: {
          root: {
            textAlign: i18n.language === 'ar' ? 'right' : 'left',
            fontFamily: font,
          },  
      },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            textAlign: language === "ar" ? "right" : "left",
            fontFamily: font,
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            fontFamily: font,
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          primary: {
            fontFamily: font,
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            fontFamily: font,
          },
        },
      },
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)', // same as your sx
            backdropFilter: 'blur(10px)', // ✅ use 'backdropFilter' (better for background)
          },
        },
      },
    },
    palette:
      mode === "dark"
        ? {
            mode: "dark",
            primary: {
              main: "#ff5252",
            },
          }
        : {},
  });
  
  
  
  let router = createBrowserRouter([
    {
      path: "/",
      element: getInitialElement(language)
    },
    // {
    //   path: "/goldCourse",
    //   element: <GoldCourseNew />
    // },
    // SignUp route protection
    {
      path:"/",
      element:<SignupProtection />,
      children:[
        {
      path: "/signup",
      element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><SignUp mode={mode} setMode={setMode}/></Suspense></ErrorBoundary>
    },
    {
      path: "/signingup",
      element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><SignUpAccount mode={mode} setMode={setMode}/></Suspense></ErrorBoundary>
    },
    {
      path: "/reset-password",
      element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><ForgotPassword mode={mode} setMode={setMode}/></Suspense></ErrorBoundary>
    },
      ]
    },
    // {
    //   path: "/signup",
    //   element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><SignUp mode={mode} setMode={setMode}/></Suspense></ErrorBoundary>
    // },
    // {
    //   path: "/signingup",
    //   element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><SignUpAccount mode={mode} setMode={setMode}/></Suspense></ErrorBoundary>
    // },
    // {
    //   path: "/reset-password",
    //   element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><ForgotPassword/></Suspense></ErrorBoundary>
    // },
    // Payment routes protection
    {
      path:"/",
      element:<PaymentRouteProtection />,
      children:[
        {
          path:"/payment",
          element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><PaymentForm/></Suspense></ErrorBoundary>,
        },
        {
          path:"/plans",
          element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><CancelSubscription/></Suspense></ErrorBoundary>,
        },
        {
          path:"/upgradeplan",
          element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><UpgradePlan/></Suspense></ErrorBoundary>,
        },
      ]
    },
    {
      path: "/Dashboard",
      element: <RouteProtection />,
      children: [
        {
          path: "/Dashboard/",
          element: <Dashboard drawerWidth={drawerWidth} setDrawerWidth={setDrawerWidth} setMode={setMode} mode={mode}/>,
          children: [
            {path: "/Dashboard/", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}>{(LicenceType === 3||LicenceType === 5) ?<GamizignWorld setMode={setMode} mode={mode} /> : <Insights setMode={setMode} mode={mode} />}</Suspense></ErrorBoundary>},
            {path: "/Dashboard/CreateCourse", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><Activity setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>},
            // Tabs routes here
            {path: "/Dashboard/questionList", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><QuestionList setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>},
            {path: "/Dashboard/refQuestionList", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><EditReferencedQList setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>},
            {path: "/Dashboard/Courses", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<CoursesSkeleton/>}><Gamizign setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>},
            {path: "/Dashboard/insights", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><Insights setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>},
            // {path: "/Dashboard/instructors", element: <Instructors />},
            {path: "/Dashboard/learnerList", element: LearnersList === 'show' ? <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><LearnerList /></Suspense></ErrorBoundary> : <></>},
            // {path: "/Dashboard/users", element: <Users />},
            // {path: "/Dashboard/rewards", element: <Rewards />},
            {path: "/Dashboard/settings", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><Settings setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>},
            // {path: "/Dashboard/help", element: <Help />},
            // {t('CreateNew')} 
            // {path: "/Dashboard/newcourse", element: <NewCourse setMode={setMode} mode={mode} />},
            {path: "/Dashboard/newcourse", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/newcourse", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><NewCourse setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/newAiCourse", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/newAiCourse", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><NewAiCourse setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/customizeAiCourse", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/customizeAiCourse", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><CustomizeAiCourse setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/adding", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/adding", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><Adding setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/creatingPptx", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/creatingPptx", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><CreatingPptx setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/creatingPdf", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/creatingPdf", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><CreatingPdf setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/customizing", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/customizing", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><Customizing setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/saveQuestions", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/saveQuestions", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><SavingQuestions setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/chooseGame", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/chooseGame", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><ChooseGame setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/gameDone", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/gameDone", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><GameDone setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            {path: "/Dashboard/play", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><PlayGame setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>},
            // Patch 3 Journey course
            {path: "/Dashboard/activityType", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/activityType", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><AddingActivityType setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            // Multi Activity Journey course
            {path: "/Dashboard/multiActivities", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/multiActivities", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><MultiActivy setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},
            // Question List 
            {path: "/Dashboard/DownloadQuestionsList", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><PdfDownloadQuestionList setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>},
            {path: "/Dashboard/EditQuestionsList", element: <ProtectPlanRoutes/>, children:[{path: "/Dashboard/EditQuestionsList", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<EditQuestionListSkeleton/>}><QuestionListEdit setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>}]},    
            {path: "/Dashboard/Chat", element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><Chat /></Suspense></ErrorBoundary>},
          ]
        },
      ]},
    {
      path:"/SuperAdmin",
      element: <SuperAdmin></SuperAdmin>
    },
    
    // Gamizign your courses
    {
      path: "/Course",
      element: <RouteProtection />, // Wrap the parent route with RouteProtection
      children: [
        {
          path: "/Course/",
          element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><CourseBar drawerWidth={drawerWidth} setDrawerWidth={setDrawerWidth} setMode={setMode} mode={mode}/></Suspense></ErrorBoundary>,
          children: [
            {path: "/Course/", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><CourseAnalytics setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>,},
            {path: "/Course/players", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><Players setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>,},
            {path: "/Course/HomeWork", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><HomeWork setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>,},
            // {path: "/Course/CourseSetting", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><CourseSetting setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>,},
            {path: "/Course/ViewCourse", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><ViewCourse setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>,},
            // {path: "/Course/PublishCourse", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><PublishCourse /></Suspense></ErrorBoundary>,},
            {path: "/Course/ActivityEvaluation", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><ActivityEvaluation setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>,},
            {path: "/Course/LearnerEvaluation", element: <ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><LearnerEva setMode={setMode} mode={mode} /></Suspense></ErrorBoundary>,},
          ]
        },
      ]},
  
    // Admin Client routing
    {
      path: "/Admin",
      element:<AdminRouteProtection/>,
      children:[
        {
          path: "/Admin",
          element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><Admin drawerWidth={drawerWidth} setDrawerWidth={setDrawerWidth} setMode={setMode} mode={mode}/></Suspense></ErrorBoundary>
        },
        {
          path: "/Admin/InstructorsPerformace",
          element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><AllInstructorsPerformance setMode={setMode} mode={mode}/></Suspense></ErrorBoundary>
        },
        {
          path: "/Admin/StudnetsPerformace",
          element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><AllStudentsPerformance setMode={setMode} mode={mode}/></Suspense></ErrorBoundary>
        },
        {
          path: "/Admin/ViewQuestions",
          element:<ErrorBoundary FallbackComponent={ErrorCard}><Suspense fallback={<LoadingComponent/>}><ViewQuestionsList setMode={setMode} mode={mode}/></Suspense></ErrorBoundary>
        },
      ]
    },
    
  ])
  //Import Mixpanel SDK
 
  // Near entry of your product, init Mixpanel
  mixpanel.init("42c90e09b0e41a2471bdc94b8fa7b127", {
    debug: true,
    track_pageview: true,
    persistence: "localStorage",
  });
  clarity.init('l2n6imfomk');

  return (
    <CacheProvider value={cacheRtl}>

    <ThemeProvider theme={theme}>
      <div className={mode === 'dark' ? 'dark min-h-screen bg-slate-950 text-slate-100' : 'min-h-screen bg-slate-50 text-slate-800'}>
        
      <HelmetProvider>
        {NetworkStatusVar==='offline'?<OfflineUI/>:<RouterProvider router={router} />}
        <NetworkStatus setNetworkStatusVar={setNetworkStatusVar}/>
        <BrowserUpdate />
        </HelmetProvider>
        {/* <SignInPage/>  */}
      </div>
    </ThemeProvider>
    </CacheProvider>
  );
}

export default App;
